export default class Auth {
  constructor(authData) {
    this.token = authData.token;
    this.refreshToken = authData.refreshToken;
  }
}
